import gql from "graphql-tag";

const BLOG_COUNT_QUERY = gql`
    query UniversityBlogPostsCount {
        universityBlogPostsCount(status: READY_TO_PUBLISH)
    }
`;

export default BLOG_COUNT_QUERY;
